export const ALLOCATION = 'allocation'
export const CPM = 'cpm'
export const CPC = 'cpc'
export const VIEWABLE_CPM = 'viewable_cpm'
